module.exports = __webpack_public_path__ + "img/1440.1bbf9bbc.jpg";